import React , {useState, useEffect}from 'react';
import ReactDOM from 'react-dom';
import MapCityData from '../../../util/mapCityData';
import { history } from '../../../history/history';

const Modal = ({ isShowing, hide}) => {

const [disable] =useState("disableButton");
 
  const closePopup = () => {
    document.body.classList.remove('hide_overflow');
    hide();
  }

  const getCity = e =>{
    let city = e.target.text;
    MapCityData.map(c =>{
      if(c.fullName.trim() === city.trim()){
        history.push({pathname:'/package' ,state:{lat: c.lat, lon : c.lon, city}});
      }
    });
    document.body.classList.remove('hide_overflow');
  }

return(   
  isShowing?  <div>
  <div className="modal-overlay">
     <div className="station-modal-dialog">
       <div className="station-modal-content">
       <div className="station-modal-header" onClick={closePopup}>
          <button type="button" className="close"><span>×</span></button>
        </div>
        <div className="station-modal_body">
          <h3 className="station-list-header">STATIONS <span>LIST</span></h3>
          <div className="station_list_wrapper scrollbar scroll_style">
            <div className="station_list">
             <ul>


    
             <li>        
                 <span className="state_list"> Metros </span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Delhi   </a>
                 <a onClick={getCity}>Mumbai   </a>
                 <a onClick={getCity}>Bangalore  </a>   
                 <a onClick={getCity}>Chennai   </a>
                 <a onClick={getCity}>Kolkata  </a> 
                 <a onClick={getCity}>Hyderabad  </a>  
                                                                   
                 </div>
               </li>


               <li>        
                 <span className="state_list"> Punjab / Haryana / Himachal / J&K </span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Chandigarh   </a>
                 <a onClick={getCity}>Hisar   </a>                
                 <a onClick={getCity}>Jammu  </a>
                 <a onClick={getCity}>Srinagar   </a>
                 <a onClick={getCity}>Amritsar  </a>  
                 <a onClick={getCity}>Jalandhar  </a>
                 <a onClick={getCity}>Patiala  </a>       
                 <a onClick={getCity}>Shimla   </a>                                
                 </div>
               </li>


               <li>    
                 <span className="state_list">Rajasthan</span>
                 <div className="station_wrapper">

                 <a onClick={getCity}>Bikaner</a>   
                 <a onClick={getCity}>Ajmer</a>                                           
                   <a onClick={getCity}>Jodhpur</a>
                   <a onClick={getCity}>Kota</a>
                   <a onClick={getCity}>Udaipur</a>
                 </div>
               </li>


               <li>        
                 <span className="state_list"> Uttar Pradesh  </span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Agra     </a>
                 <a onClick={getCity}>Aligarh    </a>
                 <a onClick={getCity}>Allahabad     </a>
                 <a onClick={getCity}>Bareilly  </a>
                 <a onClick={getCity}>Gorakhpur   </a>
                 <a onClick={getCity}>Jhansi  </a>  
                 <a onClick={getCity}>Kanpur  </a>    
                 <a onClick={getCity}>Lucknow  </a>  
                 <a onClick={getCity}>Varanasi  </a>                                                  
                 </div>
               </li>


               <li>                
                 <span className="state_list">Madhya Pradesh</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Indore</a>  
                 <a onClick={getCity}>Bhopal</a> 
                 <a onClick={getCity}>Gwalior</a> 
                     
                                    
                 </div>
               </li>


               <li>        
                 <span className="state_list">Bihar / Jharkhand / East </span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Muzaffarpur   </a>
                 <a onClick={getCity}>Patna   </a>
                 <a onClick={getCity}>Jamshedpur   </a>
                 <a onClick={getCity}>Ranchi  </a>
                 <a onClick={getCity}>Asansol  </a>  
                 <a onClick={getCity}>Bhubaneswar   </a>
                 <a onClick={getCity}>Rourkela   </a>
                                          
                 </div>
               </li>


               <li>        
                 <span className="state_list">North East </span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Guwahati  </a>
                 <a onClick={getCity}>Agartala  </a>  
                 <a onClick={getCity}>Aizawl </a>                     
                 <a onClick={getCity}>Itanagar  </a>               
                 <a onClick={getCity}>Shillong  </a>                                      
                 </div>
               </li>


               <li>        
                 <span className="state_list"> Gujarat </span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Baroda    </a>
                 <a onClick={getCity}>Rajkot   </a>
                 <a onClick={getCity}>Surat    </a>                                                            
                 </div>
               </li>


               <li>                
                 <span className="state_list">Maharashtra & Goa</span>
                 <div className="station_wrapper">                

                 <a onClick={getCity}>Pune</a>   
                 <a onClick={getCity}>Sholapur</a>
                 <a onClick={getCity}>Nagpur</a>
                 <a onClick={getCity}>Aurangabad</a>
                 <a onClick={getCity}>Kolhapur</a>
                 <a onClick={getCity}>Ahmednagar</a>
                 <a onClick={getCity}>Panaji</a>
                
                 </div>
               </li>




             <li>        
                 <span className="state_list">South </span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Tirupati  </a>                 
                 <a onClick={getCity}>Mangalore </a>
                 <a onClick={getCity}>Mysore </a>
                 <a onClick={getCity}>Trivandrum </a>
                 <a onClick={getCity}>Pondicherry </a>                            
                 </div>
               </li>



               {/* <li>
                 <span className="state_list">North East</span>
                 <div className="station_wrapper">
                   <a onClick={getCity}>Guwahati</a>
                   <a onClick={getCity}>Rourkela</a>
                   <a onClick={getCity}>Agartala</a>
                   <a onClick={getCity}>Aizawl</a>
                   <a onClick={getCity}>Itanagar</a>
                   <a onClick={getCity}>Shillong</a>
                 </div>
               </li> */}



               {/* <li>        
                 <span className="state_list">Metros</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Delhi</a>
                 <a onClick={getCity}>Mumbai</a>
                 <a onClick={getCity}>Bangalore</a>
                 <a onClick={getCity}>Hyderabad</a>
                 <a onClick={getCity}>Kolkata</a>
                 <a onClick={getCity}>Chennai</a>
                 <a onClick={getCity}>Pune</a>                 
                 </div>
               </li>




               <li>                
                 <span className="state_list">Maharashtra</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Sholapur</a>
                 <a onClick={getCity}>Nagpur</a>
                 <a onClick={getCity}>Aurangabad</a>
                 <a onClick={getCity}>Kolhapur</a>
                 <a onClick={getCity}>Ahmednagar</a>
                 </div>
               </li>



               <li>                
                 <span className="state_list">Madhya Pradesh</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Indore</a>
                 <a onClick={getCity}>Bhopal</a>      
                 <a onClick={getCity}>Gwalior</a>
                 
                           
                 </div>
               </li>



               <li>                
                 <span className="state_list">Gujrat</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Ahmedabad</a>
                 <a onClick={getCity}>Surat</a>                
                 </div>
               </li>


               <li>                
                 <span className="state_list">Uttar Pradesh</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Noida</a>
                               
                 </div>
               </li>



               <li>            
                 <span className="state_list">UP</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Agra</a>
                 <a onClick={getCity}>Aligarh</a>
                 <a onClick={getCity}>Allahabad</a>
                 <a onClick={getCity}>Bareilly</a>
                 <a onClick={getCity}>Jhansi</a>
                 <a onClick={getCity}>Kanpur</a>
                 <a onClick={getCity}>Lucknow</a>
                 <a onClick={getCity}>Gorakhpur</a>
                 <a onClick={getCity}>Varanasi</a>
                 </div>
               </li>


            */}



               {/* <li>    
                 <span className="state_list">Rajasthan</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Bikaner</a>
                 <a onClick={getCity}>Ajmer</a>
               
                   <a onClick={getCity}>Jodhpur</a>
                   <a onClick={getCity}>Kota</a>
                   <a onClick={getCity}>Udaipur</a>
                 </div>
               </li>

               <li>              
                 <span className="state_list">Gujarat</span>

                 <div className="station_wrapper">
                 <a onClick={getCity}>Baroda</a>
                 <a onClick={getCity}>Rajkot</a>
                 <a onClick={getCity}>Surat</a>
                 </div>
               </li>


               <li>                  
                 <span className="state_list">Punjab/Haryana</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Chandigarh</a>
                 <a onClick={getCity}>Jalandhar</a>
                 <a onClick={getCity}>Amritsar</a>
                 <a onClick={getCity}>Patiala</a>
                 <a onClick={getCity}>Hisar</a>
                 </div>
               </li>

               <li>                  
                 <span className="state_list">Haryana</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Chandigarh</a>                
                 <a onClick={getCity}>Hisar</a>
                 </div>
               </li>


               <li>                        
                 <span className="state_list">Jharkhand</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Ranchi</a>
                 <a onClick={getCity}>Jamshedpur</a>
                 </div>
               </li>
               <li>                        
                 <span className="state_list">East/Bihar</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Asansol</a>
                 <a onClick={getCity}>Bhubaneswar</a>
                 <a onClick={getCity}>Muzaffarpur</a>
                 <a onClick={getCity}>Patna</a>
                 <a onClick={getCity}>Kanpur</a>
                 </div>
               </li>
               <li>
                 <span className="state_list">North East</span>
                 <div className="station_wrapper">
                   <a onClick={getCity}>Guwahati</a>
                   <a onClick={getCity}>Rourkela</a>
                   <a onClick={getCity}>Agartala</a>
                   <a onClick={getCity}>Aizawl</a>
                   <a onClick={getCity}>Itanagar</a>
                   <a onClick={getCity}>Shillong</a>
                 </div>
               </li>
               <li>                                         
                 <span className="state_list">Others</span>
                 <div className="station_wrapper">
                 <a onClick={getCity}>Pondicherry</a>
                 <a onClick={getCity}>Mangalore</a>
                 <a onClick={getCity}>Mysore</a>
                 <a onClick={getCity}>Tirupati</a>
                 <a onClick={getCity}>Trivandrum</a>
                 <a onClick={getCity}>Srinagar</a>
                 <a onClick={getCity}>Shimla</a><br/>
                 <a onClick={getCity}>Panaji</a>
                 <a onClick={getCity}>Bhopal</a>
                 <a onClick={getCity}>Indore</a>
                 <a onClick={getCity}>Jammu</a>
                 </div>
               </li> */}
               
             </ul>
            </div>
          </div>
        </div>
       </div>
     </div>
  </div>
</div>:null
)
}

export default Modal;


// WEBPACK FOOTER //
// ./web/components/admin/common/stationPopup.js